var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOtherMoreHorizontal = function SvgOtherMoreHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "evenodd",
    d: "M13.334 16a2.667 2.667 0 1 1 5.333 0 2.667 2.667 0 0 1-5.334 0M22.667 16A2.667 2.667 0 1 1 28 16a2.667 2.667 0 0 1-5.334 0M4 16a2.667 2.667 0 1 1 5.333 0A2.667 2.667 0 0 1 4 16",
    clipRule: "evenodd"
  })));
};
export default SvgOtherMoreHorizontal;